/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

  $('.collection-addtocart').click(function(e){
    e.preventDefault();
    var that = $(this);
  
    var variant = that.closest('form').find('[name="id"]').val(); // Get the variant that was added
   var quantity = that.closest('form').find('[name="quantity"]').val(); // Get the quantity that was added
    
    
  var  data = {
    "id": variant,
    "quantity": quantity
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,  //this code is for prestige theme, is to refresh the cart
      detail: {
                variant: variant,
                quantity: parseInt(quantity)
              }
      }));
    }   
    
  }); 
    $('#sidebar-cart').attr('aria-hidden','false');
  });